import {
  Breadcrumbs as ComponentWarehouseBreadcrumbs,
  type BreadcrumbsProps,
  Section,
  Spacer,
  Spacings,
} from "@polestar/component-warehouse-react";
import { useNavigate } from "@remix-run/react";
import { type MouseEvent } from "react";

const Breadcrumbs = ({ links }: BreadcrumbsProps) => {
  const navigate = useNavigate();

  const onLinkClick = (event: MouseEvent<HTMLAnchorElement>, href: string) => {
    event.preventDefault();
    navigate(href);
  };

  return (
    <Section>
      <ComponentWarehouseBreadcrumbs
        links={links.map((link) => {
          return {
            ...link,
            onClick(event) {
              onLinkClick(event, link.href);
            },
          };
        })}
      />
      <Spacer
        spacing={{
          mobile: Spacings.medium,
          tablet: Spacings.large,
        }}
      />
    </Section>
  );
};

export default Breadcrumbs;
